<template>
  <b-form-group label="PPV Packages" class="mt-2">
    <div v-if="availablePackages.length === 0" class="text-muted small">
      No PPV packages defined yet.
    </div>
    <template v-else>
      <b-form-checkbox
        v-for="pkg in availablePackages"
        :key="pkg.id"
        :checked="packageIds.includes(pkg.id)"
        @change="toggle(pkg.id, $event)"
        switch
      >
        <span class="ml-2">{{ pkg.name }}</span>
        <b-badge v-if="!pkg.is_active" variant="secondary" class="ml-1">inactive</b-badge>
      </b-form-checkbox>
      <div v-if="saving" class="text-muted small mt-1">Saving…</div>
    </template>
  </b-form-group>
</template>

<script>
// Lets editors add/remove the current video to PPV packages directly from the
// media editor. Membership is persisted independently of the media item via
// /admin/api/v2/ppv-packages/media/:mediaId (mirrors the @update side-save pattern).
export default {
  name: 'MediaPpvPackages',

  props: {
    mediaId: { type: String, required: true }
  },

  data() {
    return {
      packageIds: [],
      saving: false
    }
  },

  computed: {
    availablePackages() {
      // Active packages, plus any (possibly inactive) this item already belongs to.
      const all = this.$store.state.media.options.ppvPackages || []
      return all.filter(p => p.is_active || this.packageIds.includes(p.id))
    }
  },

  methods: {
    load() {
      fetch(`/admin/api/v2/ppv-packages/by-media/${this.mediaId}`)
        .then(resp => (resp.status === 200 ? resp.json() : Promise.reject(resp.statusText)))
        .then(resp => { this.packageIds = resp.data || [] })
        .catch(() => {})
    },

    toggle(packageId, checked) {
      const idx = this.packageIds.indexOf(packageId)
      if (checked && idx < 0) this.packageIds.push(packageId)
      else if (!checked && idx >= 0) this.packageIds.splice(idx, 1)
      this.save()
    },

    save() {
      this.saving = true
      fetch(`/admin/api/v2/ppv-packages/media/${this.mediaId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: { package_ids: this.packageIds } })
      })
        .then(resp => (resp.status === 200 ? resp.json() : Promise.reject(resp.statusText)))
        .then(() => { this.saving = false })
        .catch(() => {
          this.saving = false
          this.$root.app.showAlert('Error saving packages', 'danger')
        })
    }
  },

  mounted() {
    this.load()
  }
}
</script>
